import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import styled from '@emotion/styled';
import Header from './components/Header';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Home from './components/Home';
import OurWork from './components/OurWork';
import NotFound from './components/NotFound';

const Navigation = styled.nav`
  background: var(--glass-bg);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--glass-border);
  padding: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  gap: 3rem;
  justify-content: center;
  margin: 0;
  padding: 0;
  
  @media (max-width: 768px) {
    gap: 1.5rem;
    flex-wrap: wrap;
  }
`;

const NavItem = styled.li`
  a {
    color: var(--text-primary);
    font-weight: 500;
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
    
    &:hover {
      color: var(--accent-primary);
      background: rgba(157, 78, 221, 0.1);
      transform: translateY(-2px);
    }
    
    &.active {
      color: var(--accent-primary);
      background: rgba(157, 78, 221, 0.15);
    }
  }
  
  @media (max-width: 768px) {
    a {
      padding: 0.5rem 0.75rem;
      font-size: 0.95rem;
    }
  }
`;

const MainContent = styled.main`
  min-height: calc(100vh - 200px);
  padding: 2rem 0;
`;

function App() {
  return (
    <div>
      <Header />
      <Navigation>
        <div className="container">
          <NavList>
            <NavItem>
              <Link to="/">Home</Link>
            </NavItem>
            <NavItem>
              <Link to="/our-work">Our Work</Link>
            </NavItem>
            <NavItem>
              <Link to="/privacy">Privacy Policy</Link>
            </NavItem>
            <NavItem>
              <Link to="/terms">Terms of Service</Link>
            </NavItem>
          </NavList>
        </div>
      </Navigation>
      
      <MainContent>
        <div className="container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </MainContent>
    </div>
  );
}

export default App; 